export default __webpack_public_path__ + "images/44636c011c02dd839b551b7432b8e187-4_web_1919x543.jpg";